var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _activeFetch, _LocalPickup_instances, createAbortController_fn, _fetchAvailability;
import { C as Component } from "./component-cLJ9vlHA.js";
import { m as morph } from "./morph-BX9Iqu9G.js";
import { C as CustomEvents } from "./events-DeC3n8dp.js";
import "./critical-Da0Dmhh9.js";
import "./utilities-2Suih3Nm.js";
class LocalPickup extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _LocalPickup_instances);
    __privateAdd(this, _activeFetch);
    __publicField(this, "handleVariantPickerUpdate", (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productUrl = event.detail.data.newProduct.url;
      }
      const variantId = event.detail.resource ? event.detail.resource.id : null;
      const variantAvailable = event.detail.resource ? event.detail.resource.available : null;
      if (variantId !== this.dataset.variantId) {
        if (variantId && variantAvailable) {
          this.dataset.variantId = variantId;
          __privateGet(this, _fetchAvailability).call(this, variantId);
        } else {
          this.setAttribute("hidden", "");
        }
      }
    });
    __privateAdd(this, _fetchAvailability, (variantId) => {
      if (!variantId) return;
      const abortController = __privateMethod(this, _LocalPickup_instances, createAbortController_fn).call(this);
      const url = this.dataset.productUrl;
      fetch(`${url}?variant=${variantId}&section_id=${this.dataset.sectionId}`, {
        signal: abortController.signal
      }).then((response) => response.text()).then((text) => {
        if (abortController.signal.aborted) return;
        const html = new DOMParser().parseFromString(text, "text/html");
        const wrapper = html.querySelector(`local-pickup[data-variant-id="${variantId}"]`);
        if (!wrapper.hasAttribute("hidden")) {
          this.removeAttribute("hidden");
          morph(this, wrapper);
        } else this.setAttribute("hidden", "");
      }).catch((_e) => {
        if (abortController.signal.aborted) return;
        this.setAttribute("hidden", "");
      });
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const section = this.closest(`.shopify-section`);
    if (!section) return;
    section == null ? void 0 : section.addEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
    this.disconnectedCallback = () => {
      section == null ? void 0 : section.removeEventListener(CustomEvents.variantPickerUpdate, this.handleVariantPickerUpdate);
    };
  }
}
_activeFetch = new WeakMap();
_LocalPickup_instances = new WeakSet();
createAbortController_fn = function() {
  if (__privateGet(this, _activeFetch)) __privateGet(this, _activeFetch).abort();
  __privateSet(this, _activeFetch, new AbortController());
  return __privateGet(this, _activeFetch);
};
_fetchAvailability = new WeakMap();
if (!customElements.get("local-pickup")) {
  customElements.define("local-pickup", LocalPickup);
}
